export const millionairesConnectVideos = [
  ['Supernatural Increase', 'n_DZw9LEJUs'],
  ['Supernatural Increase Part 2', 'WBXO0YLpdsQ'],
  ['Fix Your Mind', 'GA2_WJQMOjg'],
  ['Fix Your Mind Part 2', '-T2mCyWjtUY'],
  ['Fix Your Mind Part 3', 'FwIVGeeGWEc'],
  ['Fix Your Mind Part 4', 'u9cnVdDrLS8'],
  ['Fix Your Mind Part 5', 'u9cnVdDrLS8'],
  ['Fix Your Mind Part 6', 'VMWxVlesxlY'],
  ['Fix Your Mind Part 7', '-8TcmsHvn2E'],
  ['Fixing the Mind Part 8', 'CNVhR9C2mSM'],
  ['Fixing the Mind Part 9', '-0QPnvsFzfk'],
  ['Thinking Your Way to Wealth', 'CNVhR9C2mSM'],
  ['Mastering Innovation', 'GSl7Pb3Er2w'],
  ['Mastering Innovation Part 2', 'mnxwuB_0ErU'],
  ['Faith for Wealth Creation', 'HexDhBj0zhw'],
  ['Understanding Wealth', 'erLnjq5GjJ4'],
  ['Understanding Wealth Part 2', '9Q7l3wI97oc'],
  ['Understanding Wealth Part 3', 'U3Vem6kchKo'],
  ['Mending the Nets', 'bguRf7K5Klg'],
  ['Mending the Nets Part 2', 'aweHvnbWoLY'],
  ['Mending the Nets Part 3', '0GznJlyS5KM'],
  ['Praying and Covenanting', 'hLzFQHQSQ-0'],
  ['Praying and Covenanting Part 2', 'J_j1dEN5frQ'],
  ['Praying and Covenanting Part 3', 'R31cIsbxLnM'],
  ['The Power of Covenant', '1VNBLD6h9dQ'],
  ['Creating Wealth', '4Zp3n56xFL0'],
  ['Creating Wealth Part 2', 'VPIm6mgubKw'],
  ['Creating Wealth Part 3', 'XreJJzDaL_E'],
  ['Creating Wealth Part 4', 'AS7QZzRko9Q'],
  ['Creating Wealth Part 5', '7StSYKb-sBw'],
  ['The Wealth Transfer', 'RinuGQbnR-I'],
  ['The Wealth Transfer Part 2', '64A5u7bYn_8'],
  ['The Wealth Transfer Part 3', 'BPFjUe741Gs'],
  ['The Wealth Transfer Part 4', 'iT4aaOOQeAc'],
  ['Taking the Hill of God', 'RlQPYJJcnwA'],
  ['Fixing Your Thinking', '-6CLuxt7kZg'],
  ['Fixing Your Thinking Part 2', 'Tt_kHR6yQAs'],
  ['Supernatural Encounters', 'KXTG4UAylhc'],
  ['Power of a Name', 'xc2b_ODPs7c'],
  ['Wisdom of the Sages', 'b8zXL50h090'],
  ['Wisdom of the Sages Part 2', 'IfTLVLzBAys'],
  ['Wisdom of the Sages Part 3', 'TxkTaAigx6I'],
  ['Wisdom of the Sages Part 4', 'Vq34terkxZk'],
  ['Breakthrough Encounters', 'DwgkU4uyCZ4'],
  ['Breakthrough Encounters Part 2', 'ezN8Sj_Oaz0'],
  ['Breakthrough Encounters Part 3', 'IvTnO9mIZiY'],
  ['Breakthrough Encounters Part 4', 'PjAKkjObLlE'],
  ['Biblical Basis of Getting Out of Debt', 'Ei9GPEWy7K4'],
  ['NLP', '0tOXxRktcr8'],
  ['NLP Part 2', 'BYHi5abRInQ'],
  ['NLP Part 3', 'oa6lgQgBLPk'],
  ['NLP Part 4', 'omtApgktoyU'],
  ['Bonus', 'extPbasNaJo'],
  ['Praying and Covenanting — Added Version', '2oO_n0et2Dg']
];

// Keep the original supplied list above for reference, but expose a clean,
// stable lesson sequence to the classroom. Two supplied rows point to videos
// already used by an earlier row, so the student only has to complete each
// actual video once.
export const millionairesConnectLessons = millionairesConnectVideos
  .filter(([, videoId], index, videos) => (
    videos.findIndex(([, candidateId]) => candidateId === videoId) === index
  ))
  .map(([title, videoId], index, lessons) => ({
    id: `mc-lesson-${videoId}`,
    title,
    videoId,
    order: index + 1,
    total: lessons.length
  }));

export const millionairesConnectLessonResources = millionairesConnectLessons.map((lesson) => ({
  id: lesson.id,
  lessonId: lesson.id,
  title: lesson.title,
  description: `Guided video lesson ${lesson.order} of ${lesson.total}`,
  module: 'Millionaires Connect',
  type: 'video',
  season: 'Season 6',
  folder: 'Season 6',
  duration: 'Streaming',
  size: 'View only',
  isPaid: true,
  downloadable: false,
  isMillionairesConnectVideo: true,
  videoId: lesson.videoId,
  sequenceIndex: lesson.order - 1,
  sequenceNumber: lesson.order,
  sequenceTotal: lesson.total,
  embedUrl: `https://www.youtube-nocookie.com/embed/${lesson.videoId}`
}));

export const familyEconomyVideos = [
  ['Breaking Slavery and Birthing a Family Economy', 'UPUmYWyVz10'],
  ['Lesson 1 — The Abraham Blueprint', 'hrb8i532HOA'],
  ['Lesson 2 — The Abraham Blueprint', 'VgUTu63z0zk'],
  ['Lesson 3 — The Adam Blueprint', '7jcqoZM4RyE'],
  ['Lesson 4 Part 1 — The Tribes Follow the Blueprint', 'N_pzDp5Kf18'],
  ['Lesson 4 Part 2 — The Tribes Follow the Blueprint', 'RDTmzeG0kew'],
  ['Lesson 5 — Jacob Blesses the Families', 'wd_liDwkjWI'],
  ['Lesson 7 Part 1 — The Husband & Wife Team', 'Mpjp3fiVKs0'],
  ['Lesson 7 Part 2 — The Husband & Wife Team', 'T5bF-64M5xE'],
  ['Lesson 9 Part 1 — Birthing Family Ideas', 'v9jA_NzIsbg'],
  ['Lesson 9 Part 2 — Birthing Family Ideas', '54_0MbK4iZ0'],
  ['Lesson 15 — Conflict Resolution in Family Economies', 'xCQRJ_uDVBY']
];

export const economyProgramOffers = [
  {
    slug: 'millionaires-connect',
    title: 'Millionaires Connect',
    image: '/School Of SHEM Millionaires Connect Banner.png',
    options: [
      {
        title: 'Live Programme',
        price: 'R2 500 for the full programme',
        details: [
          'Sign up and join the live classes',
          '3 August 2026 – 30 October 2026',
          'Monday to Friday, 05:00 – 06:00 CAT',
          'Sessions via Zoom (link sent upon registration)',
          'Assignments that will stretch and grow you',
          'Birth a strategy that will bring your first million',
          'Register and set yourself a new economic season'
        ]
      },
      {
        title: 'Recorded Programme',
        price: 'R3 000 for the full programme',
        details: ['Join the recorded sessions from the previous season', 'Work at your own pace', `Access to ${millionairesConnectLessons.length} recorded video sessions`]
      }
    ],
    videos: millionairesConnectVideos
  },
  {
    slug: 'building-a-family-economy',
    title: 'Building a Family Economy',
    image: '/School Of SHEM Building A family Economy.png',
    options: [{
      title: 'Full Course',
      price: 'R3 000 for the full course',
      details: ['20 lessons to take you through daily family economic development', 'Study book and workbook available in store']
    }],
    videos: familyEconomyVideos
  }
];
